import { SetupAuditTrailView } from '@types';

import { CollectionResponse, createGetEndpoint } from '@sonar-software/sonar-http';

export type GetSetupAuditTrailViewsResponse = CollectionResponse<SetupAuditTrailView>;

export const getSetupAuditTrailViews = createGetEndpoint<void, GetSetupAuditTrailViewsResponse>(
	'/api/v3/setup-audit-trail/views'
);
